const titleToggle = () => {

    document.addEventListener('DOMContentLoaded', function () {
        var titleCheckBox = document.getElementById('chkTitle') as HTMLInputElement;
        var labelCheckBox = titleCheckBox.parentElement.getElementsByTagName('label');
        if (!titleCheckBox.parentElement.contains(labelCheckBox[0])) {
            var newLable = document.createElement('label');
            newLable.setAttribute('for', 'ContentPlaceHolder1_ContentPlaceHolder2_chkTitle');
            newLable.setAttribute('id', 'checkBox-label');
            newLable.classList.add('title-unchecked');
            titleCheckBox.parentElement.appendChild(newLable);
        }
        setCheckBox();

        var labelCheckBox = titleCheckBox.parentElement.getElementsByTagName('label');

        var selectCategory = document.getElementById('drpCategory') as HTMLSelectElement;
        var selectBrand = document.getElementById('drpBrand') as HTMLSelectElement;

        setTextPosition();

        selectCategory.onchange = function () {
            getCategoryandBrand();
            SetDimentions();
        }

        selectBrand.onchange = function () {
            getCategoryandBrand();
        }


        titleCheckBox.onclick = function () {
            setCheckBox();
        }

        function setTextPosition() {
            var tableInput = document.getElementById('txtTitle');
            var paddingRight = labelCheckBox[0].offsetWidth + 10;
            tableInput.style.paddingRight = paddingRight + 'px';
            
        }

        function setCheckBox() {
            if (titleCheckBox.checked) {
                labelCheckBox[0].classList.add('title-checked');
                labelCheckBox[0].classList.remove('title-unchecked');
            } else {
                labelCheckBox[0].classList.add('title-unchecked');
                labelCheckBox[0].classList.remove('title-checked');
            }
        }

        function getCategoryandBrand() {
            labelCheckBox[0].innerHTML = "";
            var categoryValue = selectCategory.options[selectCategory.selectedIndex].text;
            var categoryInPeranthesis = categoryValue.match(/\(([^)]+)\)/);
            if (categoryInPeranthesis) {
                categoryValue = " " + categoryInPeranthesis[1];
            }
            var textNode1 = document.createTextNode(categoryValue);
            labelCheckBox[0].appendChild(textNode1);
            var brandValue = selectBrand.options[selectBrand.selectedIndex].text;
            var brandInPeranthesis = brandValue.match(/\(([^)]+)\)/);
            if (brandInPeranthesis) {
                brandValue = " " + brandInPeranthesis[1];
            }
            var textNode2 = document.createTextNode(brandValue);
            labelCheckBox[0].appendChild(textNode2);
            setTextPosition();
        }

        function SetDimentions() {
            var option = selectCategory.options[selectCategory.selectedIndex];
            var width = option.getAttribute('data-width');
            var height = option.getAttribute('data-height');
            var depth = option.getAttribute('data-depth');

            if (width !== "0") {
                (document.getElementsByClassName("js-lblWidth")[0] as HTMLElement).innerText = width;
            } else {
                (document.getElementsByClassName("js-lblWidth")[0] as HTMLElement).innerText = "-";
            }

            if (height !== "0") {
                (document.getElementsByClassName("js-lblHeight")[0] as HTMLElement).innerText = height;
            } else {
                (document.getElementsByClassName("js-lblHeight")[0] as HTMLElement).innerText = "-";
            }

            if (depth !== "0") {
                (document.getElementsByClassName("js-lblDepth")[0] as HTMLElement).innerText = depth;
            } else {
               (document.getElementsByClassName("js-lblDepth")[0] as HTMLElement).innerText = "-";
            }
        }

    });

};

export {
    titleToggle
};
